/* eslint-disable @typescript-eslint/no-explicit-any */
import BlogList from '@/components/BlogList'
import { FormAddress, FormButton, FormTextRequire } from '@/components/Form'
import { PinIcon, SearchIcon, SelectedIcon } from '@/components/Icon/HeaderIcon'
import { PicoIcon } from '@/components/Icon/PicoIcon'
import { BannerType } from '@/constants'
import { useAuth } from '@/containers'
import { useAddressForm } from '@/hooks/useAddressForm'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type { BannerList, Store } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBanner,
  getBottomMenu,
  getConfig,
  getMenus,
  getProvinces,
  getQuickMenu,
} from '@/utils/endpoint'
import {
  GoogleMap,
  InfoWindowF,
  MarkerF,
  useLoadScript,
} from '@react-google-maps/api'
import clsx from 'clsx'
import { getCookies } from 'cookies-next'
import { Form, Formik } from 'formik'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect, useMemo, useState } from 'react'
const HomeBanner = dynamic(() => import('@/components/HomeBanner'), {
  ssr: false,
})

interface StorePageProps {
  pageDetail: any
  categoryDetail: any
  banner: BannerList[]
  pageType: string
}

const StorePage = ({ pageDetail, banner }: StorePageProps) => {
  const t = useTranslations('ProductDetail')
  const [markers, setMarkers] = useState<any[]>([])
  const [clicked, setClicked] = useState(true)
  const [mapCenter, setMapCenter] = useState<any>({
    lat: 21.036843354207953,
    lng: 105.7851571,
  })

  const libraries = useMemo(() => ['places'], [])

  const mapOptions = useMemo(
    () => ({
      disableDefaultUI: true,
      fullscreenControl: true,
      clickableIcons: true,
      zoomControl: true,
    }),
    []
  )

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY as string,
    libraries: libraries as any,
  })
  const addr = useAddressForm()
  useEffect(() => {
    addr.loadProvinces('old')
  }, [])

  const { storeList, getListStore, storeSelected, setStoreSelected } = useAuth()

  const middleBanner = useMemo(() => {
    return banner.filter(banner => {
      return banner.type === BannerType.HOME && banner.status === 1
    })
  }, [banner])

  useEffect(() => {
    getListStore()
  }, [])

  useEffect(() => {
    if (storeList) {
      const defaultStore =
        storeList.find(e => e.def) || storeList.find(e => e.code === 'XT')
      if (defaultStore) {
        setStoreSelected(defaultStore)
        setMapCenter(defaultStore)
        setMarkers([defaultStore])
      }
    }
  }, [storeList])

  const onMapClick = (item: Store) => {
    setMapCenter(item)
    setMarkers([item])
  }

  return (
    <Main
      meta={
        <Meta
          title={'Danh sách trung tâm'}
          description={'Danh sách trung tâm'}
          keywords={getTranslate(pageDetail?.data?.keywords) || []}
          imageUrl={pageDetail?.data?.thumbnail}
        />
      }
    >
      <section className='store'>
        <h3 className='text-HeadlineMedium mb-[15px] font-bold'>
          Hệ thống siêu thị
        </h3>
        <div className='storeSearch bg-dark-1400 px-[20px] py-[11px]'>
          <Formik
            initialValues={{
              districtCode: '',
              provinceCode: '',
            }}
            // validationSchema={translateSchema('chooseDestination', t)}
            onSubmit={async values => {
              try {
                await getListStore(values)
              } catch (error) {
                console.error('Error fetching stores:', error)
              }
            }}
          >
            {props => (
              <Form
                className='flex flex-row gap-x-[20px]'
                onSubmit={props?.handleSubmit}
              >
                <div className='formItem'>
                  <span className=''>{t('provincePld')}</span>
                  <FormAddress
                    className='mt-[5px] w-[306px] max-w-[306px] rounded bg-white'
                    classSelectButtonName='rounded'
                    onChange={e => {
                      addr.onProvinceChange(e.target.value)
                      props?.setFieldValue('provinceCode', e.target.value)
                    }}
                    value={props?.values?.provinceCode}
                    placeholder={t('provincePld')}
                    name='provinceCode'
                    classNarrow='!px-2'
                    placeholderColor='text-dark-400/70'
                    data={addr.provinces}
                  />
                  {props?.errors.provinceCode && (
                    <FormTextRequire className=' text-fieldInput text-sm font-normal text-primary-second'>
                      {props?.errors.provinceCode as string}
                    </FormTextRequire>
                  )}
                </div>
                <div className='formItem'>
                  <span className=''>{t('districtPld')}</span>
                  <FormAddress
                    className='mt-[5px] w-[306px] max-w-[306px] rounded bg-white'
                    classSelectButtonName='rounded'
                    onChange={e => {
                      props?.setFieldValue('districtCode', e.target.value)
                    }}
                    value={props?.values?.districtCode}
                    placeholder={t('districtPld')}
                    name='districtCode'
                    classNarrow='!px-2'
                    placeholderColor='text-dark-400/70'
                    data={addr.districts}
                  />
                  {props?.errors.districtCode && (
                    <FormTextRequire className=' text-fieldInput text-sm font-normal text-primary-second'>
                      {props?.errors.districtCode as string}
                    </FormTextRequire>
                  )}
                </div>
                <FormButton
                  className={clsx(
                    'disabled:text-[rgb(0 0 0 / 25%)] mt-[29px] flex h-[48px] w-full max-w-[170px] items-center justify-center rounded border bg-blue-900 text-fieldInput font-bold uppercase text-white disabled:outline-none'
                  )}
                >
                  <SearchIcon className='mr-[10px]' /> Tìm kiếm
                </FormButton>
                <FormButton
                  className={clsx(
                    'disabled:text-[rgb(0 0 0 / 25%)] mt-[29px] flex h-[48px] w-full max-w-[275px] items-center justify-center rounded border border-blue-900 text-fieldInput font-bold text-blue-900 disabled:outline-none'
                  )}
                >
                  <PinIcon className='mr-[10px]' />
                  Xem cửa hàng gần nhất
                </FormButton>
              </Form>
            )}
          </Formik>
        </div>
        <div className='storeMainContent mb-[80px] mt-[15px]'>
          <h4 className='mb-[10px] text-fieldLabel font-bold'>
            Danh sách trung tâm
          </h4>
          <div className='grid grid-cols-2'>
            <div className='storeList'>
              <div className='listLocation flex max-h-[530px] flex-row flex-wrap gap-3 overflow-y-auto pr-1'>
                {storeList && storeList.length > 0 ? (
                  storeList.map((item, index) => (
                    <div
                      key={index}
                      className={`${
                        storeSelected?._id === item._id &&
                        'border-orange bg-dark-1400'
                      } box-content block max-h-[90px] min-h-[58px] w-full cursor-pointer overflow-hidden rounded px-3 pt-1 outline-none `}
                      onClick={() => {
                        onMapClick(item)
                        setStoreSelected(item)
                        setClicked(true)
                      }}
                    >
                      <div className='flex flex-wrap items-center'>
                        <span
                          className={`mt-[4px] w-[30px] max-w-[30px] flex-[30px]`}
                        >
                          {storeSelected?._id === item._id ? (
                            <SelectedIcon />
                          ) : (
                            <span className='block h-[18px] w-[18px] overflow-hidden rounded-[100%] border border-dark-700'></span>
                          )}
                        </span>
                        <div className='flex max-w-[calc(100%-30px)] flex-[calc(100%-30px)] flex-row flex-wrap items-start justify-start gap-[2px] text-left'>
                          <p className={'block w-full text-base font-bold'}>
                            {getTranslate(item.name)}
                          </p>
                          <p className='block w-full text-base text-dark-500'>
                            Địa chỉ: {item.fullAddress}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <span>
                      Không có cửa hàng ở khu vực bạn chọn, vui lòng chọn địa
                      chỉ khác
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className='ggMap w-full'>
              {isLoaded && storeList && storeList.length > 0 && (
                <GoogleMap
                  options={mapOptions}
                  zoom={14}
                  center={mapCenter}
                  mapTypeId={'roadmap'}
                  mapContainerStyle={{ width: '100%', height: '530px' }}
                  onLoad={() => console.log('Map Component Loaded...')}
                >
                  {markers.length > 0 &&
                    markers.map((marker, index) => (
                      <MarkerF
                        icon='https://ecom-cdn-uat.ionah.com/2023/11/22/170067420376916674560.svg'
                        onLoad={() => console.log('Marker Loaded')}
                        key={index}
                        position={{
                          lat: marker.lat,
                          lng: marker.lng,
                        }}
                        onClick={() => setClicked(true)}
                      >
                        {clicked && (
                          <InfoWindowF
                            key={index}
                            position={{
                              lat: marker.lat,
                              lng: marker.lng,
                            }}
                            onCloseClick={() => setClicked(false)}
                          >
                            <div className='py-[15px] pl-[15px] pr-[13px]'>
                              <PicoIcon className='mb-[15px]' />
                              <h3 className=' mb-[6px] text-Headline font-bold  text-dark-400'>
                                {getTranslate(marker.name)}
                              </h3>
                              <span className='mb-1.5 block text-dark-400'>
                                Điện thoại:{' '}
                                <strong className='font-bold'>
                                  {marker.phoneNumber}
                                </strong>
                              </span>
                              <span className=' text-dark-400'>
                                Địa chỉ: {marker.fullAddress}
                              </span>
                            </div>
                          </InfoWindowF>
                        )}
                      </MarkerF>
                    ))}
                </GoogleMap>
              )}
            </div>
          </div>
        </div>
      </section>
      <div className='wrapper mb-[80px]'>
        <BlogList title={t('blogListTitle')} subTitle={t('blogListSubTitle')} />
        <HomeBanner
          banner={middleBanner[1]?.items}
          layout={middleBanner[1]?.layout}
        />
      </div>
    </Main>
  )
}

export default StorePage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const [stores, menus, banner, quickMenu, bottomMenu, systemConfig] =
    await Promise.all([
      getProvinces(),
      getMenus(),
      getBanner(),
      getQuickMenu(),
      getBottomMenu(),
      getConfig(),
    ])

  return {
    props: {
      stores,
      menus,
      banner,
      language,
      messages,
      quickMenu,
      bottomMenu,
      systemConfig,
      token: token || null,
    },
  }
}
